import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Bilder from "../../Detalj/Bilder";

import {
  deleteMiljogebyrerBilder,
  getMiljogebyr,
  getMiljogebyrBilder,
  getMiljogebyrerHistorikk,
  putMiljogebyrerBilder,
} from "../../../../actions/miljogebyrerActions";
import { bypatruljen, juridisk } from "../../../../constants/roles";
import { authorized } from "../../../../utils/authorizationUtils";

const isAuthorizedToPostAndPutBilder = () =>
  authorized([bypatruljen.saksbehandler, bypatruljen.saksbehandleradmin]);

const isAuthorizedForRediger = () =>
  authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    juridisk.saksbehandler,
  ]);

const isAuthorizedToDeleteImage = () =>
  authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    juridisk.saksbehandler,
  ]);

export default function BildContainer({
  miljogebyrId,
  BilderButtonsContainer,
  checkbox,
}) {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const bilder = useSelector((state) => state.miljogebyr?.bilder);
  const dispatch = useDispatch();

  const [thumbnailBilder, setThumbnailBilder] = useState([]);
  const [lightboxBilder, setLightboxBilder] = useState([]);
  const [bilderFallback, setBilderFallback] = useState([]);

  const fetchBilder = () => {
    dispatch(
      getMiljogebyrBilder(
        miljogebyrId,
        { s3BucketCategory: "miljogebyrer_thumbnail" },
        false,
      ),
    )
      .then((tb) => setThumbnailBilder(tb))
      .catch(() => {
        // Fallback for when thumbnails are not available
        dispatch(getMiljogebyrBilder(miljogebyrId)).then((b) =>
          setBilderFallback(b),
        );
      });

    dispatch(
      getMiljogebyrBilder(
        miljogebyrId,
        { s3BucketCategory: "miljogebyrer_lightbox" },
        false,
      ),
    ).then((lb) => setLightboxBilder(lb));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchBilder();
  }, []);

  const bildePropString = JSON.stringify(
    bilder?.map((b) => ({ id: b.id, isGoodQuality: b.isGoodQuality })),
  );
  useEffect(() => {
    fetchBilder();
  }, [bildePropString]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDeleteImageClick = async (bildeId) => {
    await dispatch(deleteMiljogebyrerBilder(miljogebyrId, bildeId));
    dispatch(getMiljogebyrerHistorikk(miljogebyrId));
    await dispatch(getMiljogebyr(miljogebyrId));
  };

  const handleCheckboxChange = (event) => {
    const bildeId = event.target.id;
    const bildeGoodQuality = event.target.checked;

    if (thumbnailBilder.length > 0) {
      setThumbnailBilder((prev) =>
        prev.map((bild) =>
          bild.id === bildeId
            ? { ...bild, isGoodQuality: bildeGoodQuality }
            : bild,
        ),
      );
    } else {
      setBilderFallback((prev) =>
        prev.map((bild) =>
          bild.id === bildeId
            ? { ...bild, isGoodQuality: bildeGoodQuality }
            : bild,
        ),
      );
    }

    dispatch(
      putMiljogebyrerBilder(
        miljogebyr.id,
        event.target.id,
        event.target.checked,
      ),
    )
      .then(() => dispatch(getMiljogebyrerHistorikk(miljogebyrId)))
      .catch(() => {
        if (thumbnailBilder.length > 0) {
          setThumbnailBilder((prev) =>
            prev.map((bild) =>
              bild.id === bildeId
                ? { ...bild, isGoodQuality: bildeGoodQuality }
                : bild,
            ),
          );
        } else {
          setBilderFallback((prev) =>
            prev.map((bild) =>
              bild.id === bildeId
                ? { ...bild, isGoodQuality: bildeGoodQuality }
                : bild,
            ),
          );
        }
      });
  };

  const isLoadingImages = () =>
    (thumbnailBilder.length > 0 &&
      lightboxBilder &&
      miljogebyr &&
      miljogebyr.bilder &&
      thumbnailBilder.length !== miljogebyr.bilder.length &&
      lightboxBilder.length !== miljogebyr.bilder.length) ||
    (bilderFallback.length > 0 &&
      miljogebyr &&
      bilderFallback.length !== miljogebyr.bilder.length);

  const imageArray =
    thumbnailBilder.length > 0 ? thumbnailBilder : bilderFallback;
  const lightboxImages =
    lightboxBilder.length > 0 ? lightboxBilder : bilderFallback;

  if (checkbox && isAuthorizedToPostAndPutBilder()) {
    return (
      <section className="detalj-miljogebyr-section-margin">
        <Bilder
          id={miljogebyrId}
          bilderButtonsContainer={
            isAuthorizedToPostAndPutBilder() ? BilderButtonsContainer : null
          }
          imageArray={imageArray}
          lightboxImages={lightboxImages}
          isLoadingImages={isLoadingImages()}
          handleDeleteImageClick={handleDeleteImageClick}
          handleCheckboxChange={handleCheckboxChange}
          checkboxText="Til ettersendelse"
          isAuthorizedForRediger={isAuthorizedForRediger()}
          isAuthorizedToDeleteImage={isAuthorizedToDeleteImage()}
        />
      </section>
    );
  }
  return (
    <section className="detalj-miljogebyr-section-margin">
      <Bilder
        id={miljogebyrId}
        bilderButtonsContainer={
          isAuthorizedToPostAndPutBilder() ? BilderButtonsContainer : null
        }
        isLoadingImages={isLoadingImages()}
        handleDeleteImageClick={handleDeleteImageClick}
        imageArray={imageArray}
        lightboxImages={lightboxImages}
        isAuthorizedForRediger={isAuthorizedForRediger()}
      />
    </section>
  );
}

BildContainer.propTypes = {
  miljogebyrId: PropTypes.string.isRequired,
  BilderButtonsContainer: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  checkbox: PropTypes.bool,
};
